import React from 'react'

import {
  Grid,
  InputAdornment,
  TextField,
  Typography,
  createStyles,
} from '@material-ui/core'
import { ChatOutlined } from '@material-ui/icons'
import { Site } from 'store/Site'
import { WithStyles, withStyles } from '@material-ui/styles'
import { SiteCommentResponseModel } from 'api/apiservice'

const styles = () =>
  createStyles({
    helperText: {
      margin: '4px 0',
      fontSize: '0.7rem',
    },
  })

export interface Props {
  readonly site: Site
  readonly accessToken: string
  readonly tenantId: number
  readonly userId: string
  readonly userEmail: string
  readonly comment: SiteCommentResponseModel | undefined
  readonly onChange?: (comment: string | SiteCommentResponseModel) => void
}

type AllProps = Props & WithStyles<typeof styles>

interface State {
  isEdited: boolean
  comment: string
  siteUpdating: boolean
}

class Comments extends React.Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props)
    this.state = {
      isEdited: false,
      siteUpdating: false,
      comment: this.props.comment?.comment || '',
    }
  }

  private handleInputChange(value, id) {
    switch (id) {
      case 'comment':
        if (value !== null) {
          let sanitizedValue = value.replace(/\r?\n|\r/g, ' ')

          if (sanitizedValue.length > 1024) {
            sanitizedValue = sanitizedValue.substring(0, 1024)
          }

          const isValid =
            sanitizedValue.trim().length > 0 && sanitizedValue.length <= 1024

          this.setState({
            comment: sanitizedValue,
            isEdited: isValid,
          })

          const updated = { ...this.props.comment, comment: sanitizedValue }
          this.props.onChange?.(updated)
        } else {
          this.setState({
            comment: '',
            isEdited: false,
          })
          this.props.onChange?.('')
        }
        break
    }
  }

  public render() {
    return (
      <>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6" color="primary">
              Add comment to site
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Add Notes (max 1024 characters)"
              placeholder="Type your notes here..."
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              onChange={(e) =>
                this.handleInputChange(e.target.value, 'comment')
              }
              value={this.state.comment}
              inputProps={{ maxLength: 1024 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ChatOutlined color="primary" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </>
    )
  }
}
export default withStyles(styles)(Comments)
